import {useState,useEffect} from "react";
import ImageWithBasePath from "../../../../core/img";
import {Link} from "react-router-dom";
import {all_routes} from "../../../router/all_routes";
import ReactApexChart from "react-apexcharts";
import {DatePicker} from "antd";
/* -- biz9 import start -- */
import {Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import {Log} from "biz9-utility";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Dashboard_App_Home = () => {
    const [val_app_title,setValAppTitle] =  useState("");
    const [val_app_status,setValAppStatus] =  useState("");
    const [val_hosting_duration,setValHostingDuration] =  useState("");
    const [app,setApp] =  useState(Storage.get_app());
    useEffect(() => {
        get_data();
    },[]);
    async function get_data() {
        /*
        let option = {};
        let search = Data_Logic.get_search(Portal_Table.APP,{app_id:Storage.get_app().app_id});
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);

        //bind_field(data);
        */
    };
 const [saleChart] = useState<any>({
    chart: {
      height: 290,
      type: 'bar',
      stacked: false, // No stacking since there's one series
      toolbar: {
        show: false,
      }
    },
    colors: ['#FF6F28'], // Orange color as in the image
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: false,
        endingShape: 'rounded',
        columnWidth: '40%'
      },
    },
    series: [{
      name: 'Monthly Data',
      data: [620, 330, 180, 270, 480, 100, 580, 150, 250, 90, 410, 500] // Approximate values from image
    }],
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '13px',
        }
      }
    },
    yaxis: {
      labels: {
        offsetX: -15,
        style: {
          colors: '#6B7280',
          fontSize: '13px',
        }
      }
    },
    grid: {
      borderColor: '#E5E7EB',
      strokeDashArray: 5,
      padding: {
        left: -8,
      },
    },
    legend: {
      show: false
    },
    dataLabels: {
      enabled: false
    },
    fill: {
      opacity: 1
    },
  });
  const [chartOptions] = useState<any>({
      chart: {
        height: 290,
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      series: [{
        data: [510, 320, 440, 600, 450, 150, 580, 190, 430, 290, 190, 290],
        name: 'Revenue'
      },
      {
        name: 'Withdrawn',
        data: [290, 120, 280, 190, 290, 290, 290, 110, 120, 130, 290, 120]
      },
    ],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "80%",
          borderRadius: 5,
          endingShape: "rounded",
        },
      },
      colors: ["#FF781A", "#45505C"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "May",
          "Mar",
          "Jun",
          "July",
          "Aug",
          "Apr",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        labels: {
          style: {
            colors: "#5D6772",
            fontSize: "14px",
          },
        },
      },
      yaxis: {
        min: 0,
        max: 600,
        labels: {
          offsetX: -15,
          style: {
            colors: "#5D6772",
            fontSize: "13px",
          },
        },
      },
      grid: {
        borderColor: "#E2E4E6",
        strokeDashArray: 5,
        padding: {
          left: -8,
          right: -15,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return `${val}%`;
          },
        },
      },
    })


 return (
    <>
      {/* Page Content */}
      <div className="page-wrapper">
        <div className="page-content content pb-0 bg-light">
          <div className="main-title mb-4">
            <h4>Dashboard</h4>
          </div>
          {/* status */}
          <div className="row status-info">
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-start">
                    <div className="avatar avatar-md bg-muted rounded-circle me-2 d-flex align-item-center justify-content-center text-center avatar-info">
                      <i className="ti ti-new-section text-white d-flex align-items-center justify-content-center" />
                    </div>
                    <div>
                      <p className="mb-1">APP ID</p>
                      <h6 className="mb-0">{app.app_id}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-start">
                    <div className="avatar avatar-md bg-warning rounded-circle me-2 d-flex align-item-center justify-content-center text-center avatar-info">
                      <i className="ti ti-checks text-white d-flex align-items-center justify-content-center" />
                    </div>
                    <div>
                      <p className="mb-1">URL</p>
                      <h6 className="mb-0">{app.url}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-start">
                    <div className="avatar avatar-md bg-info rounded-circle me-2 d-flex align-item-center justify-content-center text-center avatar-info">
                      <i className="ti ti-heart text-white d-flex align-items-center justify-content-center" />
                    </div>
                    <div>
                      <p className="mb-1">Service URL</p>
                      <h6 className="mb-0">{app.service_url}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-start">
                    <div className="avatar avatar-md bg-pink rounded-circle me-2 d-flex align-item-center justify-content-center text-center avatar-info">
                      <i className="ti ti-star text-white d-flex align-items-center justify-content-center" />
                    </div>
                    <div>
                      <p className="mb-1">Cancelled</p>
                      <h6 className="mb-0">₹500,000</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* status */}
          {/* Overview */}
          <div className="row">
            <div className="col-xl-3 col-md-6 d-flex">
              <div className="dash-widget flex-fill w-100">
                <div className="d-flex align-items-center mb-3">
                  <span className="dash-icon bg-success flex-shrink-0">
                    <i className="ti ti-credit-card" />
                  </span>
                  <div>
                    <p className="mb-1">Total Credit</p>
                    <h5 className="mb-0">$10,292.50</h5>
                  </div>
                </div>
                <div className="bg-light p-3 rounded-2">
                  <p className="text-dark">
                    <span className="text-secondary">+10%</span> from last week
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
              <div className="dash-widget flex-fill w-100">
                <div className="d-flex align-items-center mb-3">
                  <span className="dash-icon bg-danger flex-shrink-0">
                    <i className="ti ti-report-money" />
                  </span>
                  <div>
                    <p className="mb-1">Total Debit</p>
                    <h5 className="mb-0">$4,254.47</h5>
                  </div>
                </div>
                <div className="bg-light p-3 rounded-2">
                  <p className="text-dark">
                    <span className="text-error">-1%</span> from last week
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-12 d-flex">
              <div className="dash-earning flex-fill w-100">
                <div className="d-flex align-items-center gap-4">
                  <div className="earning-info">
                    <p className="mb-1">Earnings</p>
                    <h5>$1,57,815</h5>
                  </div>
                  <div className="earning-info">
                    <p className="mb-1">Wallet Balance</p>
                    <h5>$5690</h5>
                  </div>
                </div>
                <div className="earning-btn text-end">
                  <Link
                    to={'#'}
                    className="btn btn-primary btn-md"
                  >
                    <i className="ti ti-shopping-cart me-1" />
                    Wallet
                  </Link>
                </div>
                <Link
                  to="#"
                  className="withdraw-link"
                  data-bs-toggle="modal"
                  data-bs-target="#withdraw"
                >
                  Withdraw Funds
                </Link>
              </div>
            </div>
          </div>
          {/* /Overview */}
          {/* status */}
          <div className="row status-info">
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1"> Orders Active</p>
                      <h6 className="mb-0">454</h6>
                    </div>
                    <span className="bg-success-transparent status-icon">
                      <i className="ti ti-news text-success" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">Order Pending</p>
                      <h6 className="mb-1">47</h6>
                    </div>
                    <span className="bg-warning-transparent status-icon">
                      <i className="ti ti-shopping-cart-bolt text-warning" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">Orders Completed</p>
                      <h6 className="mb-1">25</h6>
                    </div>
                    <span className="bg-info-transparent status-icon">
                      <i className="ti ti-hexagon text-info" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">Orders Cancelled</p>
                      <h6 className="mb-1">632</h6>
                    </div>
                    <span className="bg-error-transparent status-icon">
                      <i className="ti ti-status-change text-error" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* status */}
          {/* order */}
          <div className="row">
            <div className="col-xl-8 col-md-6 d-flex">
              <div className="card dashboard-card flex-fill w-100">
                <div className="card-header">
                  <div className="gig-card-head">
                    <h5 className="mb-0">Recent Orders</h5>
                  </div>
                  <Link to={'#'} className="view-link mb-0">
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive card-table">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="table-img">
                                <Link to="#">
                                  <ImageWithBasePath
                                    src="assets/img/gigs/gigs-07.jpg"
                                    className="img-fluid rounded-pill"
                                    alt="img"
                                  />
                                </Link>
                              </div>
                              <div className="recent-payment">
                                <h6>
                                  <Link to="#">
                                    I will do creating and promoting video...
                                  </Link>
                                </h6>
                                <ul>
                                  <li>Delivery Date: 11 Jan 2025</li>
                                  <li>
                                    Buyer :{" "}
                                    <span className="text-dark">Jones</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-pink-transparent">
                              New
                            </span>
                          </td>
                          <td className="text-end amount-info">
                            <h6 className="mb-0">$1400</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="table-img">
                                <Link to="#">
                                  <ImageWithBasePath
                                    src="assets/img/gigs/gigs-08.jpg"
                                    className="img-fluid rounded-pill"
                                    alt="img"
                                  />
                                </Link>
                              </div>
                              <div className="recent-payment">
                                <h6>
                                  <Link to="#">
                                    Optimizing online presence to enhance...
                                  </Link>
                                </h6>
                                <ul>
                                  <li>Delivery Date: 11/01/2025</li>
                                  <li>
                                    Buyer :{" "}
                                    <span className="text-dark">Rose</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-pink-transparent">
                              New
                            </span>
                          </td>
                          <td className="text-end amount-info">
                            <h6 className="mb-0">$7500</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="table-img">
                                <Link to="#">
                                  <ImageWithBasePath
                                    src="assets/img/gigs/gigs-09.jpg"
                                    className="img-fluid rounded-pill"
                                    alt="img"
                                  />
                                </Link>
                              </div>
                              <div className="recent-payment">
                                <h6>
                                  <Link to="#">
                                    I will do english or german transcript of
                                    any...
                                  </Link>
                                </h6>
                                <ul>
                                  <li>Delivery Date: 09/01/2025</li>
                                  <li>
                                    Buyer :{" "}
                                    <span className="text-dark">Smith</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-pink-transparent">
                              New
                            </span>
                          </td>
                          <td className="text-end amount-info">
                            <h6 className="mb-0">$4470</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="table-img">
                                <Link to="#">
                                  <ImageWithBasePath
                                    src="assets/img/gigs/gigs-04.jpg"
                                    className="img-fluid rounded-pill"
                                    alt="img"
                                  />
                                </Link>
                              </div>
                              <div className="recent-payment">
                                <h6>
                                  <Link to="#">
                                    I will do professional lifestyle and
                                    product...
                                  </Link>
                                </h6>
                                <ul>
                                  <li>Delivery Date: 08/01/2025</li>
                                  <li>
                                    Buyer :{" "}
                                    <span className="text-dark">Lidia</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-pink-transparent">
                              New
                            </span>
                          </td>
                          <td className="text-end amount-info">
                            <h6 className="mb-0">$3570</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="table-img">
                                <Link to="#">
                                  <ImageWithBasePath
                                    src="assets/img/gigs/gigs-06.jpg"
                                    className="img-fluid rounded-pill"
                                    alt="img"
                                  />
                                </Link>
                              </div>
                              <div className="recent-payment">
                                <h6>
                                  <Link to="#">
                                    I will develop openai, dalle, chat gpt...
                                  </Link>
                                </h6>
                                <ul>
                                  <li>Delivery Date: 07/01/2025</li>
                                  <li>
                                    Buyer :{" "}
                                    <span className="text-dark">Anderson</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent text-success">
                              Completed
                            </span>
                          </td>
                          <td className="text-end amount-info">
                            <h6 className="mb-0">$4780</h6>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 d-flex">
              <div className="card files-card flex-fill w-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <div className="gig-card-head">
                    <h5 className="mb-0">Files</h5>
                  </div>
                  <Link to={'#'} className="view-link mb-0">
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive card-table">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <span className="files-icon flex-shrink-0">
                                <i className="ti ti-pdf" />
                              </span>
                              <div>
                                <h6 className="mb-1">Document.pdf</h6>
                                <p>Update on: 11 Jan 2025</p>
                              </div>
                              <div className="card-edit-icon d-flex gap-2">
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-info-circle " />{" "}
                                </Link>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-download" />{" "}
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <span className="files-icon flex-shrink-0">
                                <i className="ti ti-photo" />
                              </span>
                              <div>
                                <h6 className="mb-1">Logo.png</h6>
                                <p>Update on: 10 Jan 2025</p>
                              </div>
                              <div className="card-edit-icon d-flex gap-2">
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-info-circle " />{" "}
                                </Link>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-download" />{" "}
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <span className="files-icon flex-shrink-0">
                                <i className="ti ti-photo" />
                              </span>
                              <div>
                                <h6 className="mb-1">Worklog.png</h6>
                                <p>Update on: 09 Jan 2025</p>
                              </div>
                              <div className="card-edit-icon d-flex gap-2">
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-info-circle " />{" "}
                                </Link>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-download" />{" "}
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <span className="files-icon flex-shrink-0">
                                <i className="ti ti-photo" />
                              </span>
                              <div>
                                <h6 className="mb-1">Alter.png</h6>
                                <p>Update on: 08 Jan 2025</p>
                              </div>
                              <div className="card-edit-icon d-flex gap-2">
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-info-circle " />{" "}
                                </Link>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-download" />{" "}
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <span className="files-icon flex-shrink-0">
                                <i className="ti ti-photo" />
                              </span>
                              <div>
                                <h6 className="mb-1">Reportfile.png</h6>
                                <p>Update on: 07 Jan 2025</p>
                              </div>
                              <div className="card-edit-icon d-flex gap-2">
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-info-circle " />{" "}
                                </Link>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center justify-content-center"
                                >
                                  <i className="ti ti-download" />{" "}
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* order */}
          <div className="row">
            {/* Sales Statistics */}
            <div className="col-lg-12">
              <div className="card dashboard-card">
                <div className="card-header">
                  <div className="gig-card-head">
                    <h5 className="card-title mb-0">Sales Statistics</h5>
                  </div>
                  <div className="d-flex align-item-center gap-3">
                    <ul
                      className="revenue-tab nav nav-tabs m-0 border-0"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          className="nav-link active"
                          data-bs-toggle="tab"
                          data-bs-target="#gigs_Information"
                          aria-selected="false"
                          role="tab"
                          tabIndex={-1}
                        >
                          Gigs
                        </Link>
                      </li>
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#pay_Information"
                          aria-selected="false"
                          role="tab"
                          tabIndex={-1}
                        >
                          Payments
                        </Link>
                      </li>
                    </ul>
                    <div className="input-icon-start mb-0 position-relative year">
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar-up" />
                      </span>
                      <DatePicker className="form-control yearpicker"  picker="year" />
                      <i className="ti ti-chevron-down" />
                    </div>
                  </div>
                </div>
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="gigs_Information"
                    role="tabpanel"
                  >
                    <div className="card-body pb-0">
                      <div id="sales-income">
                        <ReactApexChart
                          id="emp-department"
                          options={saleChart}
                          series={saleChart.series}
                          type="bar"
                          height={220}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pay_Information"
                    role="tabpanel"
                  >
                    <div className="card-body pb-0">
                      <div className="d-flex align-items-center justify-content-between gap-4 flex-wrap mb-4">
                        <div className="d-flex align-items-center gap-4">
                          <div>
                            <p className="mb-1">Revenue</p>
                            <h5 className="mb-0">$9,564.30</h5>
                          </div>
                          <div>
                            <p className="mb-1">Withdrawn</p>
                            <h5 className="mb-0">$3,855.64</h5>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="revenue me-2 mb-0">
                            <i className="ti ti-point-filled" />
                            Revenue
                          </p>
                          <p className="mb-0">
                            <i className="ti ti-point-filled" />
                            Withdrawn
                          </p>
                        </div>
                      </div>
                      <div id="s-col" className="chart-set" >
                        <ReactApexChart
                                              id="emp-department"
                                              options={chartOptions}
                                              series={chartOptions.series}
                                              type="bar"
                                              height={220}
                                            />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Sales Statistics */}
          </div>
          <div className="row">
            <div className="col-xl-8 col-md-6 d-flex">
              <div className="card recent-payment-card flex-fill w-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <div className="gig-card-head">
                    <h5 className="mb-0">Recent Payments</h5>
                  </div>
                  <Link
                    to={'#'}
                    className="view-link mb-0"
                  >
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive card-table">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will create a chatbot to change leads..
                                </Link>
                              </h6>
                              <p>
                                Id : #232 <span>|</span> Order Date: 11 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent text-success">
                              <i className="ti ti-point-filled me-1" />
                              Paid
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$500</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-md"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will do english or german transcript of
                                  any..
                                </Link>
                              </h6>
                              <p>
                                Id : #231 <span>|</span> Order Date: 10 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Paid
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$500</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-md "
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will do professional lifestyle and product
                                  ph..
                                </Link>
                              </h6>
                              <p>
                                Id : #230 <span>|</span> Order Date: 09 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Paid
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$7800</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-md"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will develop openai, dall, chat gpt app
                                  for...
                                </Link>
                              </h6>
                              <p>
                                Id : #229 <span>|</span> Order Date: 08 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Paid
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$7400</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-md"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will develop Website for Ecommerce
                                </Link>
                              </h6>
                              <p>
                                Id : #414 <span>|</span> Order Date: 07 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Paid
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$1452</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-md"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 d-flex">
              <div className="card recent-payment-card flex-fill w-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <div className="gig-card-head">
                    <h5 className="mb-0">Recent Notifications</h5>
                  </div>
                  <Link
                    to={'#'}
                    className="view-link mb-0"
                  >
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive card-table">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">Your Password Changed</Link>
                              </h6>
                              <p>54 Min Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">Payment Settings Updated</Link>
                              </h6>
                              <p>1 Hour Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  Purchased Gigs “I will do professional..”
                                </Link>
                              </h6>
                              <p>1 Day Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  Added New Gig “I will do english”.
                                </Link>
                              </h6>
                              <p>15 Min Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">Profile Updated</Link>
                              </h6>
                              <p>1 Day Ago</p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
      {/* Withdraw */}
      <div
        className="modal new-modal fade"
        id="withdraw"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Withdraw Payment</h5>
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              >
                <span>x</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="amt-wrap">
                    <div className="form-wrap">
                      <label className="form-label">
                        Enter Amount ($)
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                    <ul className="amt-list">
                      <li>Or</li>
                      <li>
                        <Link to="#" className="vary-amt">
                          $50
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="vary-amt">
                          $100
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="vary-amt">
                          $150
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="buyer-method">
                    <h6>Select Payment Gateway *</h6>
                    <label className="custom_radio">
                      <input type="radio" name="payment" />
                      <span className="checkmark" />
                      Paypal
                    </label>
                    <label className="custom_radio">
                      <input type="radio" name="payment" />
                      <span className="checkmark" />
                      Stripe
                    </label>
                  </div>
                  <div className="form-wrap form-item wallet-custom">
                    <label className="form-label">
                      Email<span className="text-danger ms-1">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-wrap form-item wallet-custom">
                    <label className="form-label">
                      Password<span className="text-danger ms-1">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-md-12">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#success_credit"
                    data-bs-dismiss="modal"
                    className="btn btn-primary w-100"
                  >
                    Withdraw
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Withdraw */}
      {/* Transaction details  */}
      <div
        className="modal new-modal fade"
        id="transaction_details"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Transaction details </h5>
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body service-modal">
              <h6 className="model-head-text"> Transaction Summary </h6>
              <div className="sumary-widget">
                <div className="summary-info">
                  <h6> Transaction ID</h6>
                  <p> #TXN-20250321-00123462 </p>
                </div>
                <div className="summary-info">
                  <h6> Transaction type </h6>
                  <p> Purchase </p>
                </div>
                <div className="summary-info">
                  <h6> Amount</h6>
                  <p> $320 </p>
                </div>
                <div className="summary-info">
                  <h6> Currency</h6>
                  <p> USD </p>
                </div>
                <div className="summary-info">
                  <h6> Processing Fee</h6>
                  <p> $20 </p>
                </div>
                <div className="summary-info">
                  <h6> Payment Method</h6>
                  <p> Credit Card </p>
                </div>
                <div className="summary-info mb-0">
                  <h6> Sender</h6>
                  <p> John Doe </p>
                </div>
                <div className="summary-info mb-0">
                  <h6> Receiver</h6>
                  <p> Jane Smith </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Transaction details */}
    </>
  );
};

export default Dashboard_App_Home;
